<template>

  <div class="post-bar offer-post-bar">
    <div class="post_topbar">
      <div class="usy-dt">
        <div class="usy-dt">
          <img class="img-bvx" :src="task.user.mid_avatar" :alt="task.user.name + ' avatar'"
          style="float: left;">
          <div class="usy-name">
            <a :href="task.url">
              <h3 style="font-size: 21px;">{{task.category.title}}</h3>
            </a>
          </div>
        </div>
      </div>
<!--      <div class="ed-opts">-->
<!--        <a href="#" title="" class="ed-opts-open"> </a>-->
<!--          <ul class="ed-options">-->
<!--            <li><a href="#" title="">Edit Post</a></li>-->
<!--            <li><a href="#" title="">Unsaved</a></li>-->
<!--            <li><a href="#" title="">Unbid</a></li>-->
<!--            <li><a href="#" title="">Close</a></li>-->
<!--            <li><a href="#" title="">Hide</a></li>-->
<!--          </ul>-->
<!--        </div>-->
      </div>
      <div class="epi-sec task-epi-sec">
        <ul class="descp">
          <!-- <li><span><i class="fa fa-user text-primary"></i><a :href="task.user.url">{{task.user.name}}</a></span>
          </li> -->
          <li><span><i class="fa fa-map-marker text-primary"></i>
            {{task.suburb.name}}, {{task.suburb.state.abbreviation}}</span>
          </li>
          <li><span class="d-flex align-items-center"><i class="fa fa-clock text-primary mr-2"></i>
            <local-time :time="task.created_at" format="YYYY-MM-DD">
            </local-time>
          </span>
        </li>
      </ul>
      <ul class="bk-links">
        <li style="font-size: 16px;font-weight: 600;"><span class="task-budget">{{task.budget.title}}</span></li>

      </ul>
    </div>
    <div class="job_descp accountnone space-line">
      <p style="word-break: break-word;text-align:justify">{{task.description}}
      </p>


	  <make-offer btn_container_style="display:inline;" container_style="display:inline;"
            :user_id="user_id" :task_id="task.id" btn_type="div" v-if="task.canOffer">
    </make-offer>
  </div>
</div>
</template>

<script>
  import card from "./front/task/TaskCard"
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";

  export default {
    name: "card",
    components: {card},
    props: ["task","user_id"],
    created() {
    },
    watch: {
    }
  };
</script>
